module.exports = __webpack_public_path__ + "static/lastgen-island-1ed32c7b7ddfc2bf1c3081cdab4c8c4e.mp4";